import { render, staticRenderFns } from "./time-range-card.vue?vue&type=template&id=12c47184&scoped=true&"
import script from "./time-range-card.vue?vue&type=script&lang=ts&"
export * from "./time-range-card.vue?vue&type=script&lang=ts&"
import style0 from "./time-range-card.vue?vue&type=style&index=0&id=12c47184&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c47184",
  null
  
)

export default component.exports